// Heat Flux Density units with conversion factors to watt per square meter (W/m²)
export const heatFluxUnits = [
  { id: 'watt-per-square-meter', name: 'Watt/Square Meter', symbol: 'W/m²', plural: 'Watts/Square Meter', factor: 1 },
  { id: 'kilowatt-per-square-meter', name: 'Kilowatt/Square Meter', symbol: 'kW/m²', plural: 'Kilowatts/Square Meter', factor: 1000 },
  { id: 'watt-per-square-centimeter', name: 'Watt/Square Centimeter', symbol: 'W/cm²', plural: 'Watts/Square Centimeter', factor: 10000 },
  { id: 'watt-per-square-inch', name: 'Watt/Square Inch', symbol: 'W/in²', plural: 'Watts/Square Inch', factor: 1550.0031 },
  { id: 'calorie-per-second-sqcm', name: 'Calorie/Second·cm²', symbol: 'cal/(s·cm²)', plural: 'Calories/Second·cm²', factor: 41868 },
  { id: 'kilocalorie-per-hour-sqm', name: 'Kilocalorie/Hour·m²', symbol: 'kcal/(h·m²)', plural: 'Kilocalories/Hour·m²', factor: 1.163 },
  { id: 'btu-per-hour-sqft', name: 'BTU/Hour·ft²', symbol: 'BTU/(h·ft²)', plural: 'BTU/Hour·ft²', factor: 3.1545907 },
  { id: 'btu-per-second-sqft', name: 'BTU/Second·ft²', symbol: 'BTU/(s·ft²)', plural: 'BTU/Second·ft²', factor: 11356.5268 },
  { id: 'horsepower-per-sqft', name: 'Horsepower/Square Foot', symbol: 'hp/ft²', plural: 'Horsepower/Square Foot', factor: 8026.6494 },
];

export const popularHeatFluxConversions = [
  { from: 'watt-per-square-meter', to: 'btu-per-hour-sqft' },
  { from: 'btu-per-hour-sqft', to: 'watt-per-square-meter' },
  { from: 'kilowatt-per-square-meter', to: 'watt-per-square-meter' },
  { from: 'watt-per-square-centimeter', to: 'watt-per-square-meter' },
  { from: 'calorie-per-second-sqcm', to: 'watt-per-square-meter' },
];

export const getUnitById = (id) => heatFluxUnits.find(unit => unit.id === id);

export const convertHeatFlux = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert heat flux density units and learn the conversion formula.`;
};
